import { CommonFeatures } from "bwtk";
import Store from "../Store";
const { BasePipe } = CommonFeatures;

/**
 * rxjs pipe provider
 * this fascilitates the direct connection
 * between widgets through rxjs Observable
 * @export
 * @class Pipe
 * @extends {BasePipe}
 */
export class Pipe extends BasePipe {
    static Subscriptions(store: Store) {
        return {
        };
    }
    /**
     *Creates a static instance of Pipe.
     * @param {*} arg
     * @memberof Pipe
     */
    static instance: Pipe;
    constructor(arg: any) {
        super(arg);
        Pipe.instance = this;
    }
}
